import BrowserWarning from './BrowserWarning';
export default BrowserWarning;
